import { useContext } from "react";
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { AppContext } from "../../../App";
import { CloseRounded } from "@mui/icons-material";
import { InputQty } from "../../../controls";
import CartProdPriceInp from "./CartProdPriceInp";
import { action, controller, Server } from "../../../api/Server";
import { ToFormData } from "../../../hooks/Method";
import { useTranslation } from "react-i18next";

const CartItems = ({ cartItems, setCartItems }) => {
  const { settings, authUser, selStore } = useContext(AppContext);
  const { t } = useTranslation();

  const rmvCartItem = (item) => {
    setCartItems((x) => [...x.filter((j) => j.productId !== item.productId)]);
    // Post CancelCartItem
    if (item.productId && !item.id) {
      const cancelItem = {
        cancelItem: {
          ...item,
          productId: item.itemType === 2 ? "" : item.productId,
        },
        userId: authUser.id,
        storeId: selStore,
        date: new Date().toISOString(),
      };
      Server(controller.Sell + action.PostCancelCart).post(
        ToFormData(cancelItem)
      );
    }
  };

  const handleQtyChg = (e, productId) => {
    setCartItems((j) => [
      ...j.map((x) =>
        x.productId === productId ? { ...x, qty: e.target.value || 1 } : x
      ),
    ]);
  };

  const handleInc = (productId) => {
    setCartItems((x) => [
      ...x.map((j) =>
        j.productId === productId ? { ...j, qty: parseFloat(j.qty) + 1 } : j
      ),
    ]);
  };
  const handleDec = (productId) => {
    setCartItems((x) => [
      ...x.map((j) =>
        j.productId === productId
          ? { ...j, qty: parseFloat(j.qty) > 1 ? parseFloat(j.qty) - 1 : j.qty }
          : j
      ),
    ]);
  };

  return (
    <TableContainer
      sx={{
        height: { sm: "calc(100vh - 175px)", lg: "calc(100vh - 165px)" },
        overflow: "auto",
        borderRadius: "15px",
      }}
    >
      <Table stickyHeader size="small" aria-label="a dense table">
        <TableHead>
          <TableRow
            sx={{
              "&:last-child td, &:last-child th": {
                paddingTop: "5px",
                backgroundColor: "#fff",
                boxShadow: "var(--shadow-xs)",
              },
            }}
          >
            <TableCell></TableCell>
            <TableCell sx={{ minWidth: "25px", padding: "6px 8px 6px 0px" }}>
              #
            </TableCell>
            <TableCell
              className="tx-upp fw-6 gray-color"
              sx={{ letterSpacing: "0.5px", padding: "6px 8px 6px 0px" }}
            >
              {t("itemName")}
            </TableCell>
            <TableCell
              className="tx-upp fw-6 gray-color"
              sx={{ letterSpacing: "0.5px", padding: "6px 8px 6px 6px" }}
            >
              {t("qty")}
            </TableCell>
            <TableCell
              className="tx-upp fw-6 gray-color"
              sx={{ letterSpacing: "0.5px", padding: "6px 8px 6px 6px" }}
            >
              {t("price")}
            </TableCell>
            <TableCell
              align="right"
              className="tx-upp fw-6 gray-color"
              sx={{ letterSpacing: "0.5px", padding: "6px 8px 6px 16px" }}
            >
              {t("totalPrice")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cartItems.map((item, i) => (
            <TableRow hover sx={{ "td, th": { padding: "5px 0px" } }} key={i}>
              <TableCell>
                <IconButton
                  onClick={() => rmvCartItem(item)}
                  size="small"
                  className="error-color p-2 mr-10 ml-5"
                >
                  <CloseRounded className="fs-18" />
                </IconButton>
              </TableCell>
              <TableCell className="fw-6 fs-16 gray-color">
                {cartItems.length - i}
              </TableCell>
              <TableCell className="fs-16" sx={{ minWidth: "150px" }}>
                <div>
                  <Typography variant="subtitle2" className="pr-10">
                    {item.label}
                  </Typography>
                  <span className="fs-12 gray-color fw-6">{item.barcode}</span>
                </div>
              </TableCell>
              <TableCell sx={{ minWidth: "50px", pr: "7px !important" }}>
                <InputQty
                  value={item.qty}
                  onIncrease={() => handleInc(item.productId)}
                  onDecrease={() => handleDec(item.productId)}
                  onChange={(e) => handleQtyChg(e, item.productId)}
                />
              </TableCell>
              <TableCell align="left">
                <div className="d-flex a-start">
                  <CartProdPriceInp {...{ item, setCartItems }} />
                </div>
              </TableCell>
              <TableCell
                align="right"
                className="fs-16 fw-6 gray-color"
                sx={{ minWidth: "140px" }}
              >
                <span className="mr-10">
                  {settings.curSymbol}{" "}
                  {(parseFloat(item.qty || 0) * parseFloat(item.price)).toFixed(
                    settings.decimal
                  )}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CartItems;
